/**
 * Created by shadeeka on 7/14/20.
 */

export enum DateTimeModes {
  TODAY = 'TODAY',
  ONE_DAY = 'ONE_DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  CUSTOM = 'CUSTOM',
  OTHER = 'OTHER',
}
